import _ from 'lodash';
import PropTypes from 'prop-types';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { KetoProductCardImpression } from '@nerdwallet/react-marketplace-product-card';
import classNames from 'classnames';
import { DISPLAY_PAGES } from '@nerdwallet/react-marketplace-apply-now';
import appConfig from '@nerdwallet/app-config';
import SegmentImpression from '../segment-impression';

import styles from './keto-product-card.module.less';
import { PRODUCT_TYPE_UNSTRUCTURED_VERTICAL } from './utils';

const KetoUnstructuredContent = ({
  keyFacts,
  productCardImage,
  cardIdentifier,
  heading,
  analytics,
  ctaHref,
  ctaText,
  segmentImpressionId,
  pageViewId,
  identifier,
  ctaSubtext,
  identity,
  omitRating,
  omittedTabs,
  productType,
  starRating,
  badgeProps,
  includeWhyThisProduct,
  renderWhyThisProduct,
  includeWhyNerdsLoveIt,
  renderWhyNerdsLoveIt,
  location,
}) => {
  const productImage = productCardImage && {
    src: productCardImage,
    alt: heading,
  };

  const keyFactsMap = keyFacts?.map((item) => ({
    __typename: 'EntityPlacementDriver',
    description: null,
    label: item?.label,
    labelTooltip: null,
    tooltip: null,
    value: item?.text,
    valueTooltip: item?.tooltip,
    valueTooltipHasHtml: false,
  }));

  const unstructuredCardProps = {
    wrapDrivers: true,
    drivers: keyFactsMap,
  };

  const baseCard = {
    status: 'ACTIVE',
    entity_type: 'offers',
    product_type: productType,
    product: {
      status: 'ACTIVE',
    },
  };

  const segmentImpressionProps = {
    impression_id: segmentImpressionId,
    pageview_id: pageViewId,
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
    sku_level: baseCard.entity_type,
    sku_name: heading,
    sku_product_type: productType,
    sku_source: 'marketplace',
    impression_page_url: location?.pathname,
    impression_pageview_id: segmentImpressionId,
    sku_impression_id: segmentImpressionId,
  };

  return (
    <ElementImpression
      elementContent={cardIdentifier}
      elementName="KetoProductCard"
      id={`KetoProductCard--${heading}-${ctaHref}-${ctaText}`}
    >
      <SegmentImpression
        eventName="KetoProductCard Viewed"
        eventProps={segmentImpressionProps}
      >
        <div id={identifier} className={classNames(styles.ketoProductCard)}>
          <KetoProductCardImpression
            className={classNames([styles.fixUnstructuredKeyFacts])}
            analytics={analytics}
            identifier={identifier}
            ctaHref={ctaHref}
            ctaSubtext={ctaSubtext}
            ctaText={ctaText}
            displayPage={DISPLAY_PAGES.DIGITAL_MARKETING}
            hasAccordionOnMobile
            heading={heading}
            identity={identity}
            imageData={productImage}
            marketplaceEntity={baseCard}
            omitRating={omitRating}
            omittedTabs={omittedTabs}
            productType={productType}
            shouldLogImpression={false}
            starRating={_.toNumber(starRating)}
            {...badgeProps}
            {...unstructuredCardProps}
          />
          {includeWhyThisProduct ? renderWhyThisProduct() : null}
          {includeWhyNerdsLoveIt ? renderWhyNerdsLoveIt() : null}
        </div>
      </SegmentImpression>
    </ElementImpression>
  );
};

KetoUnstructuredContent.propTypes = {
  keyFacts: PropTypes.arrayOf(PropTypes.string),
  productCardImage: PropTypes.string,
  cardIdentifier: PropTypes.object,
  heading: PropTypes.string,
  badgeText: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaSubtext: PropTypes.string,
  ctaText: PropTypes.string,
  segmentImpressionId: PropTypes.string,
  pageViewId: PropTypes.string,
  identity: PropTypes.object,
  identifier: PropTypes.string,
  omitRating: PropTypes.bool,
  omittedTabs: PropTypes.bool,
  productType: PropTypes.oneOf(_.values(PRODUCT_TYPE_UNSTRUCTURED_VERTICAL)),
  starRating: PropTypes.string,
  includeWhyThisProduct: PropTypes.bool,
  includeWhyNerdsLoveIt: PropTypes.bool,
  renderWhyThisProduct: PropTypes.func,
  renderWhyNerdsLoveIt: PropTypes.func,
  badgeProps: PropTypes.object,
  analytics: PropTypes.object,
  location: PropTypes.string,
};

export default KetoUnstructuredContent;
